import * as _ from 'lodash';
import { ODataObject } from '../../interfaces/odata-model.interface';

export class ContractSectionModel {
    public entries: ContractEntryModel[] = [];
    public constructor(public header = '') {}
}

export class ContractEntryModel {
    public constructor(
        public label: string,
        public value: string,
    ) {}
}

const contractHeaderValue = 'CONTRACTHEADER';

export class ContractModel {
    public sections: ContractSectionModel[] = [];

    public static fromOData(data: ODataContractModel[]): ContractModel {
        const entries = _.sortBy(data, 'Counter');

        const contract = new ContractModel();
        let currentSection: ContractSectionModel;

        entries.forEach((entry) => {
            if (entry.ContValue === contractHeaderValue) {
                currentSection = new ContractSectionModel(entry.ContLabel);
                contract.sections.push(currentSection);
            } else {
                // entries need to be in a section. If no section was created yet, we need to do so now
                if (!currentSection) {
                    currentSection = new ContractSectionModel();
                    contract.sections.push(currentSection);
                }
                currentSection.entries.push(new ContractEntryModel(entry.ContLabel, entry.ContValue));
            }
        });

        return contract;
    }
}

export interface ODataContractModel extends ODataObject {
    Counter: number;
    ContLabel: string;
    ContValue: string;
    NotificationNo: string;
    TaskNumber: string;
    __metadata: {
        id: string;
        uri: string;
        type: 'HC_SM_NGM_58_SRV.Contract';
    };
}
